import { api } from "../api/api";

const errorHandler = (error) => {
  if (error?.code?.trim() == "ERR_NETWORK") {
    throw new Error(
      "It looks like we can't reach the server right now. Please try refreshing the page or check after sometime."
    );
  } else {
    throw new Error(error?.response?.data?.title);
  }
};

export const getEmailOrders = async (params) => {
  try {
    const response = await api.get("/api/PurchaseOrder", {
      params
    });
    return response?.data?.result?.result || [];
  } catch (error) {
    errorHandler(error);
  }
};

export const getTradingPartnersList = async (regionCode,orderType) => {
  try {
    const response = await api.get(
      `/api/PurchaseOrder/${regionCode}/TradingPartners`,
      {
        params: { orderType }
      }
    );
    return response?.data?.result?.result || [];
  } catch (error) {
    errorHandler(error);
  }
};

export const approveEmailOrders = async (payload) => {
  try {
    const response = await api.post(`/api/PurchaseOrder/Approve`, payload);
    return response?.data?.result || [];
  } catch (error) {
    errorHandler(error);
  }
};

export const rejectEmailOrders = async (payload) => {
  try {
    const response = await api.post(`/api/PurchaseOrder/Reject`, payload);
    return response?.data?.result || [];
  } catch (error) {
    errorHandler(error);
  }
};

export const getEmailContent = async (params) => {
  try {
    const response = await api.get("/api/PurchaseOrder/PurchaseOrderContent", {
      params,
      responseType: "blob"
    });
    return response || [];
  } catch (error) {
    if (error?.code?.trim() == "ERR_NETWORK") {
      throw new Error(
        "It looks like we can't reach the server right now. Please try refreshing the page or check after sometime."
      );
    } else {
      const blob = error?.response?.data;
      const errorMessage = await blob.text();

      throw new Error(errorMessage);
    }
  }
};

export const getEmailOrderTradingPartners = async (params) => {
   try {
    const response = [{id:1,labelName:'Test1',value:10},{id:2,labelName:'Test2',value:30}]
    //await api.get("/api/dummyTradingPartnerDetails", {params});
    // return response?.data?.result?.result || [];
    return response || [];
  } catch (error) {
       errorHandler(error);
  }
};

export const editPdfOrderItems = async (orderId, data) => {
  try {
    const response = await api.put(
      `/api/PurchaseOrder/${orderId}/SalesOrderLineItems`,
      data
    );
    return response?.data?.result || [];
  } catch (error) {
    errorHandler(error);
  }
}